import React from 'react';
import { Link } from 'react-router-dom';
import './AboutUs.css';

const heroBg = {
  Operations: '../../../Images/Operations.png',
  Origin:     '../../../Images/Madison2.png',
};



const AboutUs = ({ section = 'Operations' }) => {
  return (
    <>
      {/* ── HERO ── */}
      <div className="au-hero">
        <div
          className="au-hero-bg"
          style={{ backgroundImage: `url(${heroBg[section]})` }}
        />
        <div className="au-hero-overlay" />
        <div className="au-hero-content">
          <p className="au-eyebrow">About Us</p>
          <h1 className="au-hero-title">{section}</h1>
        </div>

        {/* Sub-nav sits at bottom of hero */}
        <div className="au-subnav">
          <Link to="/about/operations" className={`au-subnav-btn ${section === 'Operations' ? 'active' : ''}`}>Operations</Link>
          <Link to="/about/origin"     className={`au-subnav-btn ${section === 'Origin'     ? 'active' : ''}`}>Our Origin</Link>
          <Link to="/about/leadership" className={`au-subnav-btn ${section === 'Leadership' ? 'active' : ''}`}>Leadership</Link>
        </div>
      </div>

      {/* ── CONTENT ── */}
      <div className="au-body">

        {/* ════ OPERATIONS ════ */}
        {section === 'Operations' && (
          <>
            {/* Weekly Operations */}
            <section className="au-section">
              <div className="au-section-inner au-row">
                <div className="au-text-col">
                  <p className="au-label">Weekly Operations</p>
                  <h2>Cooking &amp; Going to the Streets</h2>
                  <p>
                    Twice a week, UW-Madison students gather at the Catholic Newman Center to cook
                    fresh, nutritious meals — or grill outside when the weather allows. After
                    preparing around 50 meals, volunteers take a moment of silence to pray or
                    reflect on what it means to love their neighbors, on the streets, in school,
                    and everywhere in between.
                  </p>
                  <p>
                    From there, we head to State Street or a local shelter to share those meals.
                    We sit at eye level, learn names, and hear stories. Many of our neighbors
                    receive food and money, but rarely someone who believes in them. That's what
                    our volunteers are here to do.
                  </p>
                  <div className="au-note">
                    During summer months and extreme weather, one mission per week is held.
                  </div>
                </div>
                <div className="au-img-col">
                  <img src="../../../Images/New123.png" alt="Weekly Operations" />
                </div>
              </div>
            </section>

            <div className="au-divider" />

            {/* Safe Haven */}
            <section className="au-section au-section-alt">
              <div className="au-section-inner au-row au-row-reverse">
                <div className="au-text-col">
                  <p className="au-label">Partnership</p>
                  <h2>Safe Haven</h2>
                  <p>
                    We've partnered with Safe Haven, a local shelter, to bring meals and
                    connection directly to those inside. Volunteers return weekly, building real
                    long-term relationships with the same individuals over time. When cold weather
                    makes the streets harder to reach, Safe Haven ensures we never miss a chance
                    to show up.
                  </p>
                  <a
                    href="https://porchlightinc.org"
                    target="_blank"
                    rel="noreferrer"
                    className="au-text-link"
                  >
                    Learn more at porchlightinc.org →
                  </a>
                </div>
                <div className="au-img-col">
                  <img src="../../../Images/JackLeft.jpeg" alt="Safe Haven" />
                </div>
              </div>
            </section>

            <div className="au-divider" />

            {/* Additional Operations */}
            <section className="au-section">
              <div className="au-section-inner au-row">
                <div className="au-text-col">
                  <p className="au-label">Beyond the Meal</p>
                  <h2>Additional Operations</h2>
                  <p>
                    Our mission extends beyond the meal. A volunteer support team walks alongside
                    individuals pursuing driver's licenses, interview clothes, resumes, and jobs.
                    We're also exploring a community fridge on State Street, already securing
                    connections to UW Dining's surplus food to keep it stocked with nutritious
                    meals. And a dedicated garden plot lets us grow fresh produce to serve our
                    neighbors directly.
                  </p>
                </div>
                <div className="au-img-col">
                  <img src="../../../Images/AdditionalOps.png" alt="Additional Operations" />
                </div>
              </div>
            </section>

            <div className="au-divider" />

            {/* Join Our Impact */}
            <section className="au-impact">
              <div className="au-impact-inner">
                <p className="au-label au-label-light">Get Involved</p>
                <h2 className="au-impact-title">Join Our Impact</h2>
                <div className="au-impact-grid">

                  <div className="au-impact-card">
                    <div className="au-impact-icon">🤝</div>
                    <h3>Volunteer</h3>
                    <p>
                      Join our GroupMe and use SignUpGenius to find a mission that fits your
                      schedule. No experience or commitment required. Everyone is welcome at
                      the table.
                    </p>
                    <a
                      href="https://groupme.com/join_group/100373061/PCqVY82E"
                      target="_blank"
                      rel="noreferrer"
                      className="au-impact-btn"
                    >
                      Join GroupMe
                    </a>
                  </div>

                  <div className="au-impact-card au-impact-card-featured">
                    <div className="au-impact-icon">💛</div>
                    <h3>Donate</h3>
                    <p>
                      Every dollar goes directly toward fresh meals and expanding services for
                      Madison's unhoused community.
                    </p>
                    <a
                      href="https://www.zeffy.com/en-US/donation-form/donate-to-make-a-difference-7510"
                      target="_blank"
                      rel="noreferrer"
                      className="au-impact-btn au-impact-btn-gold"
                    >
                      Donate Now
                    </a>
                  </div>

                  <div className="au-impact-card">
                    <div className="au-impact-icon">✉️</div>
                    <h3>Contact</h3>
                    <p>Questions? Reach out to Paul Selberg directly.</p>
                    <a href="tel:4147502031" className="au-contact-line">414-750-2031</a>
                    <a href="mailto:paulselberg1@gmail.com" className="au-contact-line">
                      paulselberg1@gmail.com
                    </a>
                  </div>

                </div>
              </div>
            </section>
          </>
        )}

        {/* ════ ORIGIN ════ */}
        {section === 'Origin' && (
          <section className="au-section">
            <div className="au-section-inner au-row">
              <div className="au-text-col">
                <p className="au-label">How It Started</p>
                <h2>Our Origin</h2>
                <p>
                  Food for Thought began with a simple conversation. During the 2023–2024 school
                  year, Paul Selberg would spend time on State Street sitting with those
                  experiencing homelessness, hearing their stories, and sharing his own.
                </p>
                <p>
                  One night he brought a fellow student, Will. They shared a meal and a heartfelt
                  conversation. Afterward, Will told Paul it was an extremely meaningful
                  experience — having simply taken the time to sit down. Inspired, Paul brought a
                  small group next. The result was the same. It became clear that this mission was
                  as powerful for volunteers as it was for those without shelter. A chance to grow
                  in empathy, step into service, and discover how simple it could be: sit down,
                  share a meal, learn a name.
                </p>
                <p>
                  That first group came up with the name together —{' '}
                  <strong>Food for Thought</strong> — the idea of sharing food for the thoughts
                  of others. As more volunteers joined, the team turned to the community to help
                  fund the mission, finding people like you who believe a shared meal can change
                  both sides of the table.
                </p>
              </div>
              <div className="au-img-col">
                <img src="../../../Images/First.png" alt="First Food for Thought Mission" />
                <p className="au-img-caption">First Food for Thought Mission — April 2024</p>
              </div>
            </div>
          </section>
        )}

        {/* ════ LEADERSHIP ════ */}
      
  {section === 'Leadership' && (
  <section className="au-section">
    <div className="au-section-inner">
      <div className="au-leadership-group">
        <h2 className="au-leadership-title">Leadership</h2>
        <div className="au-leadership-grid">
          {[
            { name: 'Paul Selberg',    role: 'President',                           image: '../../../Images/IMG_1749.PNG' },
            { name: 'Chris Nabor',     role: 'Vice President',                      image: '../../../Images/ClubMemberTwo.png' },
            { name: 'Jack Krimeier',   role: 'Operations Lead',                     image: '../../../Images/IMG_1824.jpg' },
            { name: 'Devin Llanas',    role: 'Support Teams & Mission Coordinator', image: '../../../Images/ClubMember12.png' },
            { name: 'Martina Silva',   role: 'Culinary & Mission Coordinator',      image: '../../../Images/Martina.png' },
            { name: 'William Guerrero',role: 'Expansion & Mission Coordinator',     image: '../../../Images/Will.PNG' },
            { name: 'Ruben Mendes',    role: 'ASM Coordinator',                     image: '../../../Images/IMG_4428.jpeg' },
            { name: 'Alex Roberts',    role: 'Accountant',                          image: '../../../Images/ALex.png' },
            { name: 'Kale Kimmel',    role: 'Web Developer',                          image: '../../../Images/IMG_0098 (2).PNG' },

          ].map((m, i) => (
            <div key={i} className="au-leader-card">
              {m.image ? (
                <img src={m.image} alt={m.name} />
              ) : (
                <div className="au-leader-initial">{m.name.charAt(0)}</div>
              )}
              <h4>{m.name}</h4>
              <p>{m.role}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
)}

      </div>
    </>
  );
};

export default AboutUs;